import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from 'components/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTransition from 'components/DialogTransition';
import ResponsiveDialogHeader from 'components/ResponsiveDialogHeader';

import styles from './styles';
import m from 'messages';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import SecondaryDialogButton from 'components/SecondaryDialogButton';
import sentinelNumberFormatter from 'utilities/formatters/sentinelNumberFormatter';

class MultiplePersonMatchDialog extends React.Component {

    handleClose() {
        this.props.handleClose();
    }

    render() {
        let { classes, fullScreen, baseTitle, matches } = this.props;
        const isOpen = Boolean(this.props.open);

        return (
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={isOpen}
                    TransitionComponent={DialogTransition}
                    className={classes.root}>
                    <ResponsiveDialogHeader
                        fullScreen={fullScreen}
                        title="Multiple Results Found"
                        fullScreenTitle={baseTitle}
                        handleClose={this.props.handleClose}
                        showBackIcon={false} />
                    <DialogContent className={classes.contentRoot}>
                        <List className={classes.list}>
                            {matches && matches.map((m, index) =>
                                <ListItem key={`key-${index}`} className={classes.listItem}>
                                    <ListItemAvatar>
                                        <Avatar className={classes.avatar}>
                                            <img src={"data:image/png;base64," + m.photo} alt="avatar" style={{ width: '100%' }} />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={m.name} secondary={sentinelNumberFormatter(m.sentinelNumber)} />
                                    <ListItemSecondaryAction>
                                        <Button aria-label="select" onClick={() => this.props.select(m)}>
                                            Select
                                        </Button>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )}
                        </List>
                    </DialogContent>
                    <DialogActions fullScreen={fullScreen}>
                        {!fullScreen &&
                            <SecondaryDialogButton onClick={this.props.handleClose}>
                                {m.general.cancel}
                            </SecondaryDialogButton>
                        }
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

MultiplePersonMatchDialog.propTypes = {
    matches: PropTypes.array,
    open: PropTypes.bool,
    select: PropTypes.func,
    handleClose: PropTypes.func
}

export default compose(
    withStyles(styles),
    withMobileDialog()
)(MultiplePersonMatchDialog);